var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-breadcrumbs',{staticClass:"tw-breadcrumbs",attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('router-link',{staticClass:"tw-breadcrumbs__link",class:{
        'tw-breadcrumbs__link--disabled': props.item.disabled,
        'grey--text': props.item.disabled,
      },attrs:{"to":props.item.to}},[_vm._v("\n      "+_vm._s(props.item.text)+"\n    ")])]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d099e1a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TwBreadcrumbs.vue
// module id = null
// module chunks = 